import { jsx as _jsx } from "react/jsx-runtime";
import { TopNav as EmbarkTopNav } from '@emburse/embark-header';
import { CertifyIcon, EmburseAnalyticsIcon, EmburseIcon } from '@emburse/embark-icons';
function TopNav() {
    const companyName = 'Test';
    return (_jsx("div", { style: { height: 70, marginBottom: 50 }, children: _jsx(EmbarkTopNav, { zIndex: 0, companyName: companyName, hasProducts: true, hasSideBar: true, logo: "Certify", userName: "Connor Billen", corporationAvatar: { src: EmburseIcon }, sidebarMenu: {
                menus: [
                    {
                        menuTabIcon: EmburseIcon,
                        menuTabLabel: 'Emburse'
                    }
                ]
            }, productsMenu: {
                sections: [
                    {
                        header: 'Certify',
                        items: [
                            {
                                icon: EmburseIcon,
                                iconText: 'Companies',
                                onClick: () => { }
                            },
                            {
                                icon: EmburseAnalyticsIcon,
                                iconText: 'Employees',
                                onClick: () => { }
                            },
                            {
                                icon: CertifyIcon,
                                iconText: 'Reports',
                                onClick: () => { }
                            }
                        ]
                    }
                ]
            } }) }));
}
export default TopNav;
